import React from 'react';
import {HashRouter, Routes, Route, Navigate} from 'react-router-dom';
import YelpLandingPage from './pages/YelpLandingPage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/yelp" replace />} />
        <Route path="/yelp" element={<YelpLandingPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;